import { useMemo } from "react";

import { useNotifications } from "@faire/retailer/components/Header/HeaderNotifications/hooks/useNotifications";

export const useHasHighPriorityNotification = () => {
  const { notifications } = useNotifications();
  return useMemo(
    () => notifications?.some(({ priority }) => priority === "HIGH") ?? false,
    [notifications]
  );
};
